import { defineMessages } from 'react-intl';

export default defineMessages({
    updatingSelection: {
        id: 'common.component.ComprehensiveOnlyCheckboxComponent.Updating selection...',
        defaultMessage: 'Updating selection...'
    }
});
